

$(document).ready(function(){
 

  $('.slides-container').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: '<button type="button" class="slick-prev">&#10094;</button>',
    nextArrow: '<button type="button" class="slick-next">&#10095;</button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  });
});
window.addEventListener('resize', function () {
  const slider = $('#shopify-section-template--25873148412235__slideshow_alt_VqEhnP .slick-slider');
  if (slider.length) {
    slider.slick('setPosition');
  }
});


function attachTooltip(containerSelector, tooltipSelector) {
  const containers = document.querySelectorAll(containerSelector);

  containers.forEach(container => {
    const tooltip = container.querySelector(tooltipSelector);
    if (!tooltip) return;

    // --- Desktop hover ---
    container.addEventListener('mousemove', (e) => {
      tooltip.style.display = 'block';
      tooltip.style.position = 'fixed';
      tooltip.style.left = (e.clientX + 10) + 'px';
      tooltip.style.top = (e.clientY + 10) + 'px';
    });

    container.addEventListener('mouseleave', () => {
      tooltip.style.display = 'none';
    });

    // --- Mobile touch ---
    container.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      tooltip.style.display = 'block';
      tooltip.style.position = 'fixed';
      tooltip.style.pointerEvents = 'none';

      // Center tooltip horizontally and vertically near finger
      const tooltipRect = tooltip.getBoundingClientRect();
      tooltip.style.left = (touch.clientX - tooltipRect.width / 2) + 'px';
      tooltip.style.top = (touch.clientY - tooltipRect.height - 20) + 'px';
    });

    container.addEventListener('touchmove', (e) => {
      const touch = e.touches[0];
      const tooltipRect = tooltip.getBoundingClientRect();
      tooltip.style.left = (touch.clientX - tooltipRect.width / 2) + 'px';
      tooltip.style.top = (touch.clientY - tooltipRect.height - 20) + 'px';
    });

    container.addEventListener('touchend', () => {
      tooltip.style.display = 'none';
    });
  });
}

// Apply to both types
attachTooltip('.multicolumn-card__image-wrapper', '.multicolumn-card__title');
attachTooltip('.card-wrapper-project', '.card-project-title');
attachTooltip('.mfg-image-wrap', '.mfg-product-title');
attachTooltip('.mfg-product-media', '.mfg-product-title');




$(document).ready(function () {
  const linkToBodyClass = {
    'follow-link': 'follow-set',
    'about-link':  'about-set'
  };

  $('a.follow-link, a.about-link, a.contact-link').on('click', function (e) {
    const $body = $('body');
    const $this = $(this);

    // --- CONTACT LINK (mailto) ---
    if ($this.hasClass('contact-link')) {
      e.preventDefault();               // stop Be Yours AJAX nav
      e.stopImmediatePropagation();     // block any other click handlers
      window.location.href = 'mailto:hello@studiojoyce.co.uk'; // open mail client
      return;                           // done
    }

    // --- FOLLOW LINK toggle ---
    if ($this.hasClass('follow-link')) {
      e.preventDefault();
      $body.toggleClass('follow-set').removeClass('about-set');
      return;
    }

    // --- ABOUT LINK ---
    if ($this.hasClass('about-link')) {
      e.preventDefault();
      $body.removeClass('follow-set about-set').addClass('about-set');
      return;
    }
  });

  // --- ABOUT CLOSE ---
  $('a.about-close').on('click', function (e) {
    e.preventDefault();
    $('body').removeClass('about-set');
  });
});









      $(document).ready(function () {
  let lastScrollTop = 0;
  let scrollTimer;

  $(window).on("scroll", function () {
    let currentScroll = $(this).scrollTop();

    if (currentScroll > lastScrollTop) {
      // scrolling down
      $("body").removeClass("scrolling-up").addClass("scrolling-down");
    } else if (currentScroll < lastScrollTop) {
      // scrolling up
      $("body").removeClass("scrolling-down").addClass("scrolling-up");
    }

    lastScrollTop = currentScroll;

    // Clear any previous timer
    clearTimeout(scrollTimer);

    // Remove classes after 250ms of no scroll activity
    scrollTimer = setTimeout(function () {
      $("body").removeClass("scrolling-down scrolling-up");
    }, 250);
  });
});

